import React, { Component } from 'react';

const SECTIONS = [
    {
        title: 'ข้อมูลบริษัท',
        icon: 'fas fa-building',
        fields: [
            { key: 'company_name', label: 'ชื่อบริษัท', icon: 'fas fa-building', placeholder: 'ANT Journey House Co., Ltd.' },
            { key: 'address', label: 'ที่อยู่', icon: 'fas fa-map-marker-alt', placeholder: '5/1, Floor 1, ...', textarea: true },
            { key: 'license_no', label: 'เลขที่ใบอนุญาต', icon: 'fas fa-id-card', placeholder: 'เช่น 11/10538' },
            { key: 'map_lat', label: 'ละติจูด (Lat)', icon: 'fas fa-crosshairs', placeholder: 'เช่น 13.7166' },
            { key: 'map_lng', label: 'ลองจิจูด (Lng)', icon: 'fas fa-crosshairs', placeholder: 'เช่น 100.5254' },
            { key: 'map_zoom', label: 'ระดับซูม (1-20)', icon: 'fas fa-search-plus', placeholder: '15' }
        ]
    },
    {
        title: 'ช่องทางติดต่อ',
        icon: 'fas fa-phone-alt',
        fields: [
            { key: 'phone', label: 'เบอร์โทร', icon: 'fas fa-phone', placeholder: '063-664-6150' },
            { key: 'email', label: 'อีเมล', icon: 'fas fa-envelope', placeholder: 'info@antjourney.co.th' }
        ]
    },
    {
        title: 'โซเชียลมีเดีย',
        icon: 'fas fa-share-alt',
        fields: [
            { key: 'line_id', label: 'LINE ID / URL', icon: 'fab fa-line', placeholder: '@antjourney หรือ https://line.me/R/ti/p/...', color: '#06c755' },
            { key: 'facebook_url', label: 'Facebook', icon: 'fab fa-facebook-f', placeholder: 'https://facebook.com/...', color: '#1877f2' },
            { key: 'instagram_url', label: 'Instagram', icon: 'fab fa-instagram', placeholder: 'https://instagram.com/...', color: '#e4405f' },
            { key: 'youtube_url', label: 'YouTube', icon: 'fab fa-youtube', placeholder: 'https://youtube.com/@...', color: '#ff0000' },
            { key: 'tiktok_url', label: 'TikTok', icon: 'fab fa-tiktok', placeholder: 'https://tiktok.com/@...', color: '#000' }
        ]
    }
];

export class ContactSettings extends Component {
    constructor(props) {
        super(props);
        this.state = { values: {}, loading: true, saving: false, saved: false };
    }

    componentDidMount() { this.load(); }

    load() {
        this.setState({ loading: true });
        fetch('api/sitesetting')
            .then(r => r.ok ? r.json() : {})
            .then(values => this.setState({ values: values || {}, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    upd(key, val) { this.setState({ values: { ...this.state.values, [key]: val }, saved: false }); }

    async save() {
        this.setState({ saving: true, saved: false });
        try {
            var r = await fetch('api/sitesetting', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ values: this.state.values })
            });
            if (!r.ok) throw new Error('save failed');
            this.setState({ saved: true, saving: false });
            setTimeout(() => this.setState({ saved: false }), 2500);
        } catch (e) {
            alert('บันทึกไม่สำเร็จ: ' + e.message);
            this.setState({ saving: false });
        }
    }

    render() {
        var { values, loading, saving, saved } = this.state;

        if (loading) return <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>;

        return (
            <div style={{ padding: '28px 20px 40px', maxWidth: 1000, margin: '0 auto' }}>
                <div className="d-flex justify-content-between align-items-center mb-4" style={{ flexWrap: 'wrap', gap: 12 }}>
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>
                        <i className="fas fa-info-circle" style={{ color: '#dc3545', marginRight: 6 }}></i>
                        ข้อมูลติดต่อและลิงก์โซเชียลที่แสดงที่หน้าบ้าน (footer + ฟอร์มติดต่อ) — ช่องไหนว่าง ระบบจะซ่อนอัตโนมัติ
                    </p>
                    <div className="d-flex" style={{ gap: 10 }}>
                        {saved && <span style={{ color: '#28a745', fontSize: 13, alignSelf: 'center', fontWeight: 600 }}><i className="fas fa-check-circle"></i> บันทึกแล้ว</span>}
                        <button className="btn btn-danger px-4" onClick={() => this.save()} disabled={saving} style={{ minWidth: 140 }}>
                            {saving ? <><i className="fas fa-spinner fa-spin"></i> กำลังบันทึก...</> : <><i className="fas fa-save"></i> บันทึก</>}
                        </button>
                    </div>
                </div>

                {SECTIONS.map((section, si) => (
                    <div key={si} style={{ background: '#fff', borderRadius: 12, padding: '24px 28px 28px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: 22 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingBottom: 14, marginBottom: 20, borderBottom: '1px solid #f0f0f0' }}>
                            <span style={{ width: 36, height: 36, borderRadius: 8, background: 'linear-gradient(135deg,#dc3545,#9d1a26)', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 15 }}>
                                <i className={section.icon}></i>
                            </span>
                            <div style={{ fontSize: 16, fontWeight: 800, color: '#333' }}>{section.title}</div>
                        </div>

                        <div className="row" style={{ rowGap: 28, columnGap: 0 }}>
                            {section.fields.map(f => (
                                <div key={f.key} className={f.textarea ? 'col-12' : 'col-md-6'} style={{ paddingLeft: 12, paddingRight: 12 }}>
                                    <label style={{ fontSize: 13, fontWeight: 700, color: '#555', marginBottom: 14, display: 'flex', alignItems: 'center', gap: 10 }}>
                                        <span style={{ width: 26, height: 26, borderRadius: '50%', background: f.color || '#dc3545', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12 }}>
                                            <i className={f.icon}></i>
                                        </span>
                                        {f.label}
                                    </label>
                                    {f.textarea ? (
                                        <textarea className="form-control" rows="3" placeholder={f.placeholder} value={values[f.key] || ''} onChange={e => this.upd(f.key, e.target.value)}></textarea>
                                    ) : (
                                        <input className="form-control" placeholder={f.placeholder} value={values[f.key] || ''} onChange={e => this.upd(f.key, e.target.value)} />
                                    )}
                                </div>
                            ))}
                        </div>

                        {section.title === 'ข้อมูลบริษัท' && (
                            <div style={{ marginTop: 20, padding: 16, background: '#fafafa', borderRadius: 8, border: '1px solid #eee' }}>
                                <div style={{ fontSize: 13, fontWeight: 700, color: '#555', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <i className="fas fa-map" style={{ color: '#dc3545' }}></i> ตัวอย่างแผนที่
                                    <a href="https://www.google.com/maps" target="_blank" rel="noopener noreferrer" style={{ fontSize: 11, fontWeight: 500, marginLeft: 'auto', color: '#666' }}>
                                        <i className="fas fa-external-link-alt"></i> หา Lat/Lng จาก Google Maps
                                    </a>
                                </div>
                                {values.map_lat && values.map_lng ? (
                                    <iframe title="map-preview" width="100%" height="280" frameBorder="0" style={{ border: 0, borderRadius: 6 }}
                                        src={`https://maps.google.com/maps?q=${encodeURIComponent(values.map_lat)},${encodeURIComponent(values.map_lng)}&z=${values.map_zoom || 15}&output=embed`}
                                        loading="lazy"></iframe>
                                ) : (
                                    <div style={{ height: 160, background: '#fff', border: '2px dashed #ddd', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#bbb' }}>
                                        <div style={{ textAlign: 'center' }}>
                                            <i className="fas fa-map-marked-alt" style={{ fontSize: 36 }}></i>
                                            <div style={{ fontSize: 12, marginTop: 6 }}>กรอก Lat/Lng เพื่อแสดงตัวอย่างแผนที่</div>
                                        </div>
                                    </div>
                                )}
                                <div style={{ fontSize: 11, color: '#888', marginTop: 8, lineHeight: 1.5 }}>
                                    <i className="fas fa-lightbulb" style={{ color: '#ffc107' }}></i> วิธีหา Lat/Lng: เปิด Google Maps → คลิกขวาที่จุดที่ต้องการ → คลิกค่าพิกัดเพื่อคัดลอก
                                </div>
                            </div>
                        )}
                    </div>
                ))}

                <div className="d-flex justify-content-end" style={{ gap: 10, marginTop: 8 }}>
                    {saved && <span style={{ color: '#28a745', fontSize: 13, alignSelf: 'center', fontWeight: 600 }}><i className="fas fa-check-circle"></i> บันทึกแล้ว</span>}
                    <button className="btn btn-danger px-4" onClick={() => this.save()} disabled={saving} style={{ minWidth: 140 }}>
                        {saving ? <><i className="fas fa-spinner fa-spin"></i> กำลังบันทึก...</> : <><i className="fas fa-save"></i> บันทึก</>}
                    </button>
                </div>
            </div>
        );
    }
}
